import { any } from "codelyzer/util/function";

export const initialTeamsState = {
  teams: [],
  error: undefined
};

export interface ITeamsState {
  teams: any[];
  error?: string; 
}
